import React, { memo, useEffect, useState } from "react";
import Svg, { Path } from "react-native-svg";
import { TextInput, TouchableOpacity, View } from "react-native";
import { clearOnlySelectedCategory, clearSelectedCategory } from "appRedux/reducers/filterSlice";
import { fp, spH, spV } from "utils/normalise";
import { useDispatch, useSelector } from "react-redux";

import Animated from "react-native-reanimated";
import FilterRecursiveComp from "./FilterRecursiveComp.js";
import ListView from "components/ListView.js";
import VText from "components/VText";
import { categoryArr } from "utils/Constants.js";
import { removeDiacritics } from "utils/common";
import { useGlobalSearchParams, useSegments } from "expo-router";

const FilterCategory = ({ currentFilters = {} }) => {
    const ESTIMATED_ITEM_SIZE = 70;
    const SCROLL_EVENT_THROTTLE = 64;
    const [search, setSearch] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [hasSubCategories, setHasSubCategories] = useState(true);
    const [selectedData, setSelectedData] = useState([]);

    const allSelectedFilters = useSelector((state) => state.FilterReducer.selectedFilters);
    const parentSelected = useSelector((state) => state.FilterReducer.parentSelected);

    const local = useGlobalSearchParams();

    const segments  = useSegments()
    const isCategory = segments?.includes('shop') && Object.keys(categoryArr)?.includes(segments?.[1]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (search && search?.length > 0 && currentFilters?.options && Array.isArray(currentFilters?.options)) {
            let temp = currentFilters?.options;
            let dat = temp?.filter((o) => removeDiacritics(o?.title)?.toLowerCase()?.includes(search?.toLowerCase()));
            setSearchResults(dat);
        }
    }, [search, currentFilters?.options]);

    useEffect(() => {
        if ([1, 6].includes(currentFilters?.id)) {
            let options = [...currentFilters?.options];
            let tempHasSubCategories = false;
            for (let j = 0; j < options.length; j++) {
                if (Array.isArray(options?.[j]?.options) && options?.[j]?.options?.length > 0) {
                    tempHasSubCategories = true;
                    break;
                }
            }
            setHasSubCategories(tempHasSubCategories);
        } else {
            setHasSubCategories(false);
        }
    }, [currentFilters]);

    useEffect(() => {
        if (allSelectedFilters && allSelectedFilters[currentFilters?.id]) {
            setSelectedData(allSelectedFilters[currentFilters?.id]);
        } else {
            setSelectedData([]);
        }
    }, [allSelectedFilters, currentFilters]);

    return (
        <Animated.View style={{ flex: 1, backgroundColor: "white" }}>
            <View
                style={{
                    backgroundColor: "white",
                    flex: 1,
                }}
            >
                {currentFilters?.id == 2 && (
                    <View
                        style={{
                            paddingBottom: spV(16),
                            width: "100%",
                        }}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                                padding: 8,
                                borderWidth: 1,
                                borderColor: "rgba(0, 0, 0, 0.16)",
                            }}
                        >
                            <Svg
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <Path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M14.331 16.0233C12.9147 17.069 17.3189 12.5766 16.0656 14.2843C16.097 14.2818 16.0388 14.3765 15.844 14.6138C15.844 14.6138 19.1911 17.9299 20.8341 19.6176C21.4045 20.2329 20.3753 21.4609 19.6761 20.8197C18.1883 19.3798 14.6676 15.8014 14.6622 15.7955L14.331 16.0233Z"
                                    fill="#212427"
                                    fillOpacity="0.6"
                                    stroke="#212427"
                                    strokeOpacity="0.6"
                                    strokeWidth="0.2"
                                />
                                <Path
                                    d="M9.41281 17.6999C11.5664 17.679 13.6983 16.7893 15.2313 15.2781C17.052 13.4832 17.9896 10.8278 17.6626 8.29253C17.1022 3.94821 13.5218 1 9.35928 1C6.19662 1 3.12303 2.9734 1.77483 5.83485C0.74277 8.02558 0.740679 10.6705 1.77483 12.865C3.11341 15.7064 6.13682 17.6694 9.30533 17.6999C9.3413 17.6999 9.37726 17.6999 9.41281 17.6999ZM9.31412 16.3079C6.09793 16.2771 3.0971 13.796 2.50036 10.6151C2.07968 8.37262 2.87379 5.94581 4.5281 4.35324C6.45923 2.49329 9.49477 1.87053 12.0189 2.9246C14.277 3.86771 15.9673 6.0576 16.2788 8.47023C16.5456 10.5383 15.8017 12.7057 14.3397 14.1986C13.0572 15.5083 11.2586 16.29 9.40402 16.3079C9.37391 16.3079 9.34422 16.3079 9.31412 16.3079Z"
                                    fill="#212427"
                                    fillOpacity="0.6"
                                    stroke="#212427"
                                    strokeOpacity="0.6"
                                    strokeWidth="0.2"
                                />
                            </Svg>

                            <TextInput
                                onChangeText={(text) => {
                                    setSearch(text);
                                }}
                                placeholder="Search Brands"
                                value={search}
                                style={{
                                    paddingLeft: spH(16),
                                    fontSize: fp(15),
                                    fontWeight: "350",
                                    lineHeight: fp(24),
                                    flex: 1,
                                    color: "rgba(33, 36, 39, 0.6)",
                                    fontFamily: "JosefinSans",
                                    outlineStyle: "none",
                                }}
                            />
                        </View>
                    </View>
                )}

                <View
                    style={{
                        flex: 1,
                    }}
                >
                    {((isCategory && selectedData?.length > 0) || !isCategory) && [
                            ...(currentFilters?.id == 1 ? parentSelected : []),
                            ...selectedData,
                        ] &&
                        [...(currentFilters?.id == 1 ? parentSelected : []), ...selectedData]?.length > 0 && (
                            <View
                                style={{
                                    paddingVertical: spV(16),
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    paddingBottom: spV(20),
                                    paddingTop: [1, 6].includes(currentFilters?.id) ? spV(16) : 0,
                                }}
                            >
                                <TouchableOpacity
                                    key={"clear"}
                                    onPress={() => {
                                        if (isCategory) {
                                            dispatch(clearOnlySelectedCategory(currentFilters?.id));
                                        } else {
                                            dispatch(clearSelectedCategory(currentFilters?.id));
                                        }
                                    }}
                                    style={{
                                        alignItems: "flex-end",
                                        width: "100%",
                                    }}
                                >
                                    <VText
                                        style={{
                                            color: "#FFFFFF",
                                            textDecorationLine: "underline",
                                            color: "#212427",
                                        }}
                                        text={"Clear All"}
                                    />
                                </TouchableOpacity>
                            </View>
                        )}
                    {[1, 2, 3, 5, 6, 7, 8, 9, 10].includes(currentFilters?.id) && (
                        <ListView
                            showsVerticalScrollIndicator={false}
                            data={[
                                search?.length > 0
                                    ? searchResults || []
                                    : Array.isArray(currentFilters?.options)
                                    ? currentFilters?.options
                                    : [],
                            ].flat()}
                            renderItem={({ item, index }) => {
                                return (
                                    <FilterRecursiveComp
                                        categoryID={currentFilters?.id}
                                        currentFilters={item}
                                        currentFiltersName={currentFilters?.title}
                                        key={index}
                                        hasSubCategories={hasSubCategories}
                                    />
                                );
                            }}
                            contentContainerStyle={{
                                paddingBottom: spV(200),
                            }}
                            maxToRenderPerBatch={10}
                            keyExtractor={(item, index) => `${item?.id?.toString()}_${index}_filter1`}
                            estimatedItemSize={ESTIMATED_ITEM_SIZE}
                            scrollEventThrottle={SCROLL_EVENT_THROTTLE}
                        />
                    )}
                    {/* {[6].includes(currentFilters?.id) && (
            <ListView
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{ paddingBottom: 100 }}
              data={currentFilters?.options}
              renderItem={renderItem}
              keyExtractor={(item) => item?.region}
            />
          )} */}
                </View>
            </View>
        </Animated.View>
    );
};

export default memo(FilterCategory);
